module.exports = __webpack_public_path__ + "static/media/final_05.728999bb.jpg";